<template>
  <div class="container">
    <div class="goods-card" v-for="item in couponGoodsList">
      <i
        class="el-icon-error activeDelBtn"
        @click.stop="removeCouponGoods(item)"
      ></i>
      <p>
        {{ item.modelName }} {{ item.faultTypesName }}
        {{ item.faultSubclassName }}
      </p>
      <h3 class="sku">{{ item.skuNo }}</h3>
    </div>
    <el-card
      class="add-btn"
      shadow="never"
      body-style="padding: 0"
      @click.native="addHandler"
    >
      <i class="el-icon-plus"></i>
    </el-card>

    <el-dialog
      title="添加商品"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      v-loading="goodsLoading"
    >
      <input-tag
        width="100%"
        height="200px"
        placeholder="请输入相关商品SKU，允许以逗号隔开"
        @saveTag="data => (goodsData = data)"
      ></input-tag>

      <el-button
        type="primary"
        style="margin-top: 20px;"
        @click="addNewCouponGoods"
        >保存</el-button
      >
    </el-dialog>
  </div>
</template>
<script>
import inputTag from "./inputTag";
import {
  getCouponGoodsApi,
  saveCouponGoodsApi,
  delCouponGoodsApi
} from "@/api/coupon";
export default {
  name: "couponGoods",
  components: { inputTag },
  props: {
    couponId: {
      required: true,
      type: Number | String
    }
  },
  data() {
    return {
      dialogVisible: false,
      goodsLoading: false,
      couponGoodsList: [],
      goodsData: []
    };
  },
  watch: {
    couponId: function(v) {
      if (v) {
        this.loadCouponGoods();
      } else {
        this.couponGoodsList = [];
      }
    }
  },
  methods: {
    addHandler() {
      if (!this.couponId) {
        this.$message({
          message: "请先保存基础信息后在添加",
          type: "warning"
        });
        return;
      }
      this.dialogVisible = true;
    },
    loadCouponGoods() {
      let _self = this;
      if (this.couponId) {
        getCouponGoodsApi(this.couponId).then(res => {
          if (res.data.status == 100) {
            _self.couponGoodsList = res.data.results;
          }
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.goodsData = [];
    },
    addNewCouponGoods() {
      console.log(this.goodsData);
      if (this.goodsData && this.goodsData.length > 0) {
        this.saveCouponGoods();
      } else {
        this.$message({ message: "请确认需要添加的商品SKU", type: "warning" });
      }
    },
    saveCouponGoods() {
      let _self = this;
      if (this.goodsData && this.goodsData.length > 0 && this.couponId) {
        this.goodsLoading = true;
        saveCouponGoodsApi(this.couponId, this.goodsData.split(","))
          .then(res => {
            if (res.data.status == 100) {
              _self.loadCouponGoods();
              _self.handleClose();
            } else {
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .finally(() => {
            _self.goodsLoading = false;
          });
      }
    },
    removeCouponGoods(item) {
      let _self = this;
      if (item && item.id) {
        this.$confirm(`是否删除当前商品${item.skuNo}`, "提示", {
          type: "warning"
        })
          .then(() => {
            delCouponGoodsApi(item.id).then(res => {
              if (res.data.status == 100) {
                _self.loadCouponGoods();
                _self.handleClose();
              } else {
                this.$message({ message: res.data.message, type: "warning" });
              }
            });
          })
          .catch(() => {});
      }
    }
  }
};
</script>
<style lang="scss" type="text/css" scoped>
.container {
  padding-top: 20px;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}
.goods-card {
  position: relative;
  width: 200px;
  height: 80px;
  margin: 0 20px;
  margin-top: 10px;
  border: 1px solid #c6c6c6;
  border-radius: 20px;
  padding: 10px;
  .activeDelBtn {
    display: none;
    position: absolute;
    top: 5px;
    left: 5px;
    color: #c41335;
  }
  &:hover .activeDelBtn {
    display: block;
  }
}
.add-btn {
  width: 50px;
  height: 50px;
  border: 1px dashed #c6c6c6;
  line-height: 50px;
  display: flex;
  justify-content: center;
  i {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// couponGoods.vue?22ee476a